import React, { useEffect, useState } from "react";
import api from "../../setupAxios";
import { fechaHoraES, useListado } from "../../utils";

// Historial de todo lo que pasa (accesos, citas, llegadas, WhatsApp, cambios de admin…).
export default function TabHistorial() {
  const [f, setF] = useState({ accion: "", q: "", desde: "", hasta: "" });
  const [acciones, setAcciones] = useState([]);
  const { datos, cargando, error, recargar } = useListado("/admin/historial", f, "historial");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  useEffect(() => {
    api.get("/admin/historial", { params: { limite: 1 } }).then(({ data }) => setAcciones(data.acciones || [])).catch(() => {});
  }, [datos.length]);

  return (
    <div className="card">
      <div className="card-headrow">
        <h3>📜 Historial <span className="count">{datos.length}</span></h3>
        <button className="btn btn-refresh" onClick={recargar}>🔄 Actualizar</button>
      </div>
      <div className="ci-filtros">
        <div className="field ancho"><label>Buscar (persona o detalle)</label><input value={f.q} onChange={set("q")} /></div>
        <div className="field"><label>Acción</label>
          <select value={f.accion} onChange={set("accion")}><option value="">Todas</option>{acciones.map((a) => <option key={a}>{a}</option>)}</select></div>
        <div className="field"><label>Desde</label><input type="date" value={f.desde} onChange={set("desde")} /></div>
        <div className="field"><label>Hasta</label><input type="date" value={f.hasta} onChange={set("hasta")} /></div>
        <div className="ci-acciones"><button className="btn" onClick={() => setF({ accion: "", q: "", desde: "", hasta: "" })}>Limpiar filtros</button></div>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      <p className="muted">Se muestran los 500 movimientos más recientes que cumplan los filtros.</p>
      <div className="tablewrap">
        <table className="ci-tabla t-historial">
          <thead><tr><th>Cuándo</th><th>Acción</th><th>Quién</th><th>Alumno</th><th>Detalle</th></tr></thead>
          <tbody>
            {cargando && datos.length === 0 && <tr><td colSpan={5} className="empty">Cargando…</td></tr>}
            {!cargando && datos.length === 0 && <tr><td colSpan={5} className="empty">Sin movimientos.</td></tr>}
            {datos.map((h) => (
              <tr key={h.id}>
                <td>{fechaHoraES(h.fecha_hora)}</td>
                <td className="strong">{h.accion}</td>
                <td>{h.actor || "—"}{h.actor_tipo ? <span className="muted"> ({h.actor_tipo})</span> : null}</td>
                <td>{h.alumno || "—"}</td>
                <td className="ci-hist-detalle">{h.detalle}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
